export { default } from './Facilities';
export type { Props, Props as FacilitiesMiniListingProps } from './Facilities';
